// // ============================================================
// // src/pages/SuperAdmin.js
// // ✅ Fixed token reading on every request
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
// const TK = "vidyaone_sa_token";
// const getToken = () => localStorage.getItem(TK);

// // ✅ Re-reads token fresh on every call
// const saFetch = async (path, options = {}) => {
//   const token = getToken();
//   const res = await fetch(`${BASE}/superadmin${path}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//   });
//   if (!res.ok) {
//     const err = await res.json().catch(() => ({ message: "Request failed" }));
//     throw new Error(err.message || "Request failed");
//   }
//   return res.json();
// };

// function StatusBadge({ status }) {
//   const map = {
//     trial: { bg: "#fff8e1", color: "#b45309", label: "Trial" },
//     active: { bg: "#f0fdf4", color: "#166534", label: "Active" },
//     blocked: { bg: "#fef2f2", color: "#991b1b", label: "Blocked" },
//     expired: { bg: "#f8fafc", color: "#64748b", label: "Expired" },
//   };
//   const s = map[status] || map.expired;
//   return (
//     <span
//       style={{
//         padding: "3px 10px",
//         borderRadius: 20,
//         fontSize: 11,
//         fontWeight: 700,
//         background: s.bg,
//         color: s.color,
//         border: `1px solid ${s.color}40`,
//       }}
//     >
//       {s.label}
//     </span>
//   );
// }

// function HospitalRow({ h, onAction, onDelete }) {
//   const expiry = h.subscriptionExpiry ? new Date(h.subscriptionExpiry) : null;
//   const daysLeft = expiry ? Math.ceil((expiry - new Date()) / 86400000) : null;

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 14,
//         padding: "16px 20px",
//         marginBottom: 12,
//         boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ flex: 1, minWidth: 200 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 8,
//               marginBottom: 4,
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//               {h.name}
//             </div>
//             <StatusBadge status={h.subscriptionStatus} />
//             {h.slug === "pearlsmile" && (
//               <span
//                 style={{
//                   padding: "2px 8px",
//                   borderRadius: 20,
//                   fontSize: 10,
//                   fontWeight: 700,
//                   background: "#e0f2fe",
//                   color: "#0369a1",
//                 }}
//               >
//                 Original
//               </span>
//             )}
//           </div>
//           <div style={{ fontSize: 12, color: "#64748b" }}>
//             {h.city} · {h.type || "Dental"} · /{h.slug}
//           </div>
//           <div
//             style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}
//           >
//             {[
//               { label: "Doctors", value: h.doctorCount || 0 },
//               { label: "Patients", value: h.patientCount || 0 },
//               { label: "Appointments", value: h.appointmentCount || 0 },
//             ].map((s) => (
//               <div key={s.label} style={{ textAlign: "center" }}>
//                 <div
//                   style={{ fontSize: 16, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>{s.label}</div>
//               </div>
//             ))}
//             {expiry && (
//               <div style={{ textAlign: "center" }}>
//                 <div
//                   style={{
//                     fontSize: 16,
//                     fontWeight: 700,
//                     color: daysLeft < 3 ? "#dc2626" : "#0a1628",
//                   }}
//                 >
//                   {daysLeft}d
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>Days left</div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action buttons */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: 6,
//             flexShrink: 0,
//           }}
//         >
//           {h.subscriptionStatus !== "active" && (
//             <button onClick={() => onAction(h._id, "active")} style={BTN_GREEN}>
//               ✅ Activate
//             </button>
//           )}
//           {h.subscriptionStatus !== "blocked" && h.slug !== "pearlsmile" && (
//             <button onClick={() => onAction(h._id, "blocked")} style={BTN_RED}>
//               🚫 Block
//             </button>
//           )}
//           <button onClick={() => onAction(h._id, "extend")} style={BTN_BLUE}>
//             📅 +14 days
//           </button>
//           {h.slug !== "pearlsmile" && (
//             <button
//               onClick={() => onDelete(h)}
//               style={{ ...BTN_RED, background: "#fef2f2" }}
//             >
//               🗑️ Delete
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         style={{
//           marginTop: 10,
//           paddingTop: 10,
//           borderTop: "1px solid #f1f5f9",
//           display: "flex",
//           gap: 16,
//           fontSize: 12,
//           color: "#64748b",
//           flexWrap: "wrap",
//         }}
//       >
//         <span>📞 {h.phone || "—"}</span>
//         <span>✉️ {h.email || "—"}</span>
//         <span>🗓️ Est. {h.established || "—"}</span>
//         <span
//           style={{ marginLeft: "auto", fontFamily: "monospace", fontSize: 11 }}
//         >
//           {new Date(h.createdAt).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           })}
//         </span>
//       </div>
//     </div>
//   );
// }

// const BTN = {
//   padding: "6px 12px",
//   borderRadius: 7,
//   border: "1px solid",
//   fontSize: 11,
//   fontWeight: 700,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   whiteSpace: "nowrap",
// };
// const BTN_GREEN = {
//   ...BTN,
//   borderColor: "#16a34a",
//   color: "#166534",
//   background: "#f0fdf4",
// };
// const BTN_RED = {
//   ...BTN,
//   borderColor: "#dc2626",
//   color: "#991b1b",
//   background: "#fff",
// };
// const BTN_BLUE = {
//   ...BTN,
//   borderColor: "#2563eb",
//   color: "#1d4ed8",
//   background: "#eff6ff",
// };

// function LoginScreen({ onLogin }) {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleLogin = async () => {
//     if (!username || !password) {
//       setError("Enter username and password.");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     try {
//       const res = await fetch(`${BASE}/superadmin/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);
//       localStorage.setItem(TK, data.token);
//       onLogin(data.username);
//     } catch (err) {
//       setError(err.message || "Login failed.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg,#0a1628,#0d2444)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 24,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           padding: "40px 36px",
//           width: "100%",
//           maxWidth: 400,
//           boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//         }}
//       >
//         <div style={{ textAlign: "center", marginBottom: 28 }}>
//           <div style={{ fontSize: 48, marginBottom: 8 }}>🛡️</div>
//           <h1
//             style={{
//               fontSize: 22,
//               fontWeight: 800,
//               color: "#0a1628",
//               margin: 0,
//             }}
//           >
//             VidyaOne
//           </h1>
//           <p style={{ color: "#64748b", fontSize: 13, marginTop: 4 }}>
//             Super Admin Panel
//           </p>
//         </div>
//         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//           <div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Username
//             </label>
//             <input
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               placeholder="vidyaone_admin"
//               autoComplete="off"
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Password
//             </label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter password"
//               onKeyDown={(e) => e.key === "Enter" && handleLogin()}
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <button
//             onClick={handleLogin}
//             disabled={loading}
//             style={{
//               padding: "12px",
//               borderRadius: 8,
//               border: "none",
//               background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//               color: "#fff",
//               fontWeight: 700,
//               fontSize: 14,
//               cursor: "pointer",
//               opacity: loading ? 0.7 : 1,
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {loading ? "Logging in..." : "Access Super Admin →"}
//           </button>
//           {error && (
//             <div
//               style={{ color: "#dc2626", fontSize: 12, textAlign: "center" }}
//             >
//               {error}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function SuperAdmin() {
//   const navigate = useNavigate();
//   const [loggedIn, setLoggedIn] = useState(!!getToken());
//   const [username, setUsername] = useState("");
//   const [hospitals, setHospitals] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState("");
//   const [search, setSearch] = useState("");
//   const [filterStatus, setFilter] = useState("all");

//   const showToast = (msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(""), 3500);
//   };

//   const load = useCallback(async () => {
//     if (!loggedIn) return;
//     setLoading(true);
//     try {
//       const [h, s] = await Promise.all([
//         saFetch(`/hospitals?_t=${Date.now()}`),
//         saFetch(`/stats?_t=${Date.now()}`),
//       ]);
//       setHospitals(h);
//       setStats(s);
//     } catch (err) {
//       // ✅ If token expired — logout and redirect to login
//       if (err.message === "Invalid token." || err.message === "No token.") {
//         localStorage.removeItem(TK);
//         setLoggedIn(false);
//       }
//       showToast("❌ " + err.message);
//     }
//     setLoading(false);
//   }, [loggedIn]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const handleAction = async (id, action) => {
//     try {
//       if (action === "extend") {
//         await saFetch(`/hospitals/${id}/extend-trial`, {
//           method: "PATCH",
//           body: JSON.stringify({ days: 14 }),
//         });
//         showToast("✅ Trial extended by 14 days!");
//       } else {
//         await saFetch(`/hospitals/${id}/status`, {
//           method: "PATCH",
//           body: JSON.stringify({ status: action }),
//         });
//         showToast(`✅ Status updated to ${action}!`);
//       }
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//     }
//   };

//   const handleDelete = async (h) => {
//     if (
//       !window.confirm(
//         `DELETE "${h.name}"?\n\nThis will permanently delete:\n• All doctors\n• All patients\n• All appointments\n\nThis CANNOT be undone!`,
//       )
//     )
//       return;
//     try {
//       await saFetch(`/hospitals/${h._id}`, { method: "DELETE" });
//       showToast(`✅ "${h.name}" deleted!`);
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//     }
//   };

//   if (!loggedIn) {
//     return (
//       <LoginScreen
//         onLogin={(u) => {
//           setLoggedIn(true);
//           setUsername(u);
//         }}
//       />
//     );
//   }

//   const filtered = hospitals.filter((h) => {
//     const matchSearch =
//       !search ||
//       h.name.toLowerCase().includes(search.toLowerCase()) ||
//       h.city?.toLowerCase().includes(search.toLowerCase());
//     const matchStatus =
//       filterStatus === "all" || h.subscriptionStatus === filterStatus;
//     return matchSearch && matchStatus;
//   });

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: "'DM Sans',sans-serif",
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           padding: "20px 32px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <span style={{ fontSize: 28 }}>🛡️</span>
//           <div>
//             <div style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>
//               VidyaOne Super Admin
//             </div>
//             <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//               Platform Management
//             </div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.08)",
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             ← VidyaOne
//           </button>
//           <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//             👋 {username}
//           </span>
//           <button
//             onClick={() => {
//               localStorage.removeItem(TK);
//               setLoggedIn(false);
//             }}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.1)",
//               color: "#fff",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             Logout
//           </button>
//         </div>
//       </div>

//       <div style={{ maxWidth: 1000, margin: "0 auto", padding: "28px 24px" }}>
//         {/* Stats */}
//         {stats && (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
//               gap: 12,
//               marginBottom: 24,
//             }}
//           >
//             {[
//               { label: "Total hospitals", value: stats.totalHospitals },
//               { label: "Active", value: stats.activeHospitals },
//               { label: "On trial", value: stats.trialHospitals },
//               { label: "Blocked", value: stats.blockedHospitals },
//               { label: "Total doctors", value: stats.totalDoctors },
//               { label: "Total patients", value: stats.totalPatients },
//               { label: "Appointments", value: stats.totalAppointments },
//             ].map((s) => (
//               <div
//                 key={s.label}
//                 style={{
//                   background: "#fff",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: 12,
//                   padding: "14px 16px",
//                 }}
//               >
//                 <div
//                   style={{ fontSize: 22, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
//                   {s.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Filters */}
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             marginBottom: 18,
//             flexWrap: "wrap",
//             alignItems: "center",
//           }}
//         >
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search hospital or city..."
//             style={{
//               flex: 1,
//               minWidth: 180,
//               padding: "9px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               fontSize: 13,
//               outline: "none",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           />
//           {["all", "trial", "active", "blocked", "expired"].map((s) => (
//             <button
//               key={s}
//               onClick={() => setFilter(s)}
//               style={{
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 border: "1px solid",
//                 cursor: "pointer",
//                 fontFamily: "'DM Sans',sans-serif",
//                 borderColor: filterStatus === s ? "#0d7377" : "#d1d5db",
//                 background: filterStatus === s ? "#0d7377" : "#fff",
//                 color: filterStatus === s ? "#fff" : "#374151",
//               }}
//             >
//               {s.charAt(0).toUpperCase() + s.slice(1)}
//             </button>
//           ))}
//           <button
//             onClick={load}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             🔄 Refresh
//           </button>
//         </div>

//         <div
//           style={{
//             marginBottom: 12,
//             fontSize: 13,
//             fontWeight: 700,
//             color: "#1e293b",
//           }}
//         >
//           {filtered.length} hospital{filtered.length !== 1 ? "s" : ""}
//           {filterStatus !== "all" && ` · ${filterStatus}`}
//         </div>

//         {loading ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             Loading hospitals...
//           </div>
//         ) : filtered.length === 0 ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             No hospitals found.
//           </div>
//         ) : (
//           filtered.map((h) => (
//             <HospitalRow
//               key={h._id}
//               h={h}
//               onAction={handleAction}
//               onDelete={handleDelete}
//             />
//           ))
//         )}
//       </div>

//       {/* Toast */}
//       {toast && (
//         <div
//           style={{
//             position: "fixed",
//             bottom: 24,
//             right: 24,
//             background: "#0a1628",
//             color: "#fff",
//             padding: "12px 20px",
//             borderRadius: 10,
//             fontSize: 13,
//             fontWeight: 600,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
//             zIndex: 9999,
//           }}
//         >
//           {toast}
//         </div>
//       )}
//     </div>
//   );
// }

///////////// above is correct ///////////
// // ============================================================
// // src/pages/SuperAdmin.js
// // ✅ Fixed token reading on every request
// // ✅ Fixed daysLeft calculation (floor from start of today)
// // ✅ Auto-refresh every 5 minutes
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
// const TK = "vidyaone_sa_token";
// const getToken = () => localStorage.getItem(TK);

// const saFetch = async (path, options = {}) => {
//   const token = getToken();
//   const res = await fetch(`${BASE}/superadmin${path}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//   });
//   if (!res.ok) {
//     const err = await res.json().catch(() => ({ message: "Request failed" }));
//     throw new Error(err.message || "Request failed");
//   }
//   return res.json();
// };

// function StatusBadge({ status }) {
//   const map = {
//     trial: { bg: "#fff8e1", color: "#b45309", label: "Trial" },
//     active: { bg: "#f0fdf4", color: "#166534", label: "Active" },
//     blocked: { bg: "#fef2f2", color: "#991b1b", label: "Blocked" },
//     expired: { bg: "#f8fafc", color: "#64748b", label: "Expired" },
//   };
//   const s = map[status] || map.expired;
//   return (
//     <span
//       style={{
//         padding: "3px 10px",
//         borderRadius: 20,
//         fontSize: 11,
//         fontWeight: 700,
//         background: s.bg,
//         color: s.color,
//         border: `1px solid ${s.color}40`,
//       }}
//     >
//       {s.label}
//     </span>
//   );
// }

// function HospitalRow({ h, onAction, onDelete }) {
//   const expiry = h.subscriptionExpiry ? new Date(h.subscriptionExpiry) : null;

//   // ✅ Fixed — compare from start of today using floor
//   const now = new Date();
//   now.setHours(0, 0, 0, 0);
//   const daysLeft = expiry ? Math.floor((expiry - now) / 86400000) : null;

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 14,
//         padding: "16px 20px",
//         marginBottom: 12,
//         boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ flex: 1, minWidth: 200 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 8,
//               marginBottom: 4,
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//               {h.name}
//             </div>
//             <StatusBadge status={h.subscriptionStatus} />
//             {h.slug === "pearlsmile" && (
//               <span
//                 style={{
//                   padding: "2px 8px",
//                   borderRadius: 20,
//                   fontSize: 10,
//                   fontWeight: 700,
//                   background: "#e0f2fe",
//                   color: "#0369a1",
//                 }}
//               >
//                 Original
//               </span>
//             )}
//           </div>
//           <div style={{ fontSize: 12, color: "#64748b" }}>
//             {h.city} · {h.type || "Dental"} · /{h.slug}
//           </div>
//           <div
//             style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}
//           >
//             {[
//               { label: "Doctors", value: h.doctorCount || 0 },
//               { label: "Patients", value: h.patientCount || 0 },
//               { label: "Appointments", value: h.appointmentCount || 0 },
//             ].map((s) => (
//               <div key={s.label} style={{ textAlign: "center" }}>
//                 <div
//                   style={{ fontSize: 16, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>{s.label}</div>
//               </div>
//             ))}
//             {expiry && (
//               <div style={{ textAlign: "center" }}>
//                 <div
//                   style={{
//                     fontSize: 16,
//                     fontWeight: 700,
//                     color:
//                       daysLeft < 3
//                         ? "#dc2626"
//                         : daysLeft < 7
//                           ? "#d97706"
//                           : "#0a1628",
//                   }}
//                 >
//                   {daysLeft <= 0 ? "Exp" : `${daysLeft}d`}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>Days left</div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action buttons */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: 6,
//             flexShrink: 0,
//           }}
//         >
//           {h.subscriptionStatus !== "active" && (
//             <button onClick={() => onAction(h._id, "active")} style={BTN_GREEN}>
//               ✅ Activate
//             </button>
//           )}
//           {h.subscriptionStatus !== "blocked" && h.slug !== "pearlsmile" && (
//             <button onClick={() => onAction(h._id, "blocked")} style={BTN_RED}>
//               🚫 Block
//             </button>
//           )}
//           <button onClick={() => onAction(h._id, "extend")} style={BTN_BLUE}>
//             📅 +14 days
//           </button>
//           {h.slug !== "pearlsmile" && (
//             <button
//               onClick={() => onDelete(h)}
//               style={{ ...BTN_RED, background: "#fef2f2" }}
//             >
//               🗑️ Delete
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         style={{
//           marginTop: 10,
//           paddingTop: 10,
//           borderTop: "1px solid #f1f5f9",
//           display: "flex",
//           gap: 16,
//           fontSize: 12,
//           color: "#64748b",
//           flexWrap: "wrap",
//         }}
//       >
//         <span>📞 {h.phone || "—"}</span>
//         <span>✉️ {h.email || "—"}</span>
//         <span>🗓️ Est. {h.established || "—"}</span>
//         <span
//           style={{ marginLeft: "auto", fontFamily: "monospace", fontSize: 11 }}
//         >
//           {new Date(h.createdAt).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           })}
//         </span>
//       </div>
//     </div>
//   );
// }

// const BTN = {
//   padding: "6px 12px",
//   borderRadius: 7,
//   border: "1px solid",
//   fontSize: 11,
//   fontWeight: 700,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   whiteSpace: "nowrap",
// };
// const BTN_GREEN = {
//   ...BTN,
//   borderColor: "#16a34a",
//   color: "#166534",
//   background: "#f0fdf4",
// };
// const BTN_RED = {
//   ...BTN,
//   borderColor: "#dc2626",
//   color: "#991b1b",
//   background: "#fff",
// };
// const BTN_BLUE = {
//   ...BTN,
//   borderColor: "#2563eb",
//   color: "#1d4ed8",
//   background: "#eff6ff",
// };

// function LoginScreen({ onLogin }) {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleLogin = async () => {
//     if (!username || !password) {
//       setError("Enter username and password.");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     try {
//       const res = await fetch(`${BASE}/superadmin/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);
//       localStorage.setItem(TK, data.token);
//       onLogin(data.username);
//     } catch (err) {
//       setError(err.message || "Login failed.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg,#0a1628,#0d2444)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 24,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           padding: "40px 36px",
//           width: "100%",
//           maxWidth: 400,
//           boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//         }}
//       >
//         <div style={{ textAlign: "center", marginBottom: 28 }}>
//           <div style={{ fontSize: 48, marginBottom: 8 }}>🛡️</div>
//           <h1
//             style={{
//               fontSize: 22,
//               fontWeight: 800,
//               color: "#0a1628",
//               margin: 0,
//             }}
//           >
//             VidyaOne
//           </h1>
//           <p style={{ color: "#64748b", fontSize: 13, marginTop: 4 }}>
//             Super Admin Panel
//           </p>
//         </div>
//         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//           <div>
//             <div
//               style={{
//                 background: "rgba(220,38,38,0.08)",
//                 border: "1px solid rgba(220,38,38,0.25)",
//                 borderRadius: 10,
//                 padding: "12px 16px",
//                 marginBottom: 20,
//                 textAlign: "center",
//               }}
//             >
//               <div style={{ fontSize: 18, marginBottom: 6 }}>🔒</div>
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 700,
//                   color: "#dc2626",
//                   marginBottom: 4,
//                 }}
//               >
//                 Restricted Access
//               </div>
//               <div style={{ fontSize: 12, color: "#7f1d1d", lineHeight: 1.6 }}>
//                 This area is exclusively reserved for{" "}
//                 <strong>VidyaOne Platform Administrators</strong>. Unauthorized
//                 access attempts are monitored and logged. If you are not a
//                 VidyaOne admin, please leave immediately.
//               </div>
//             </div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Username
//             </label>
//             <input
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               placeholder="vidyaone_admin"
//               autoComplete="off"
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Password
//             </label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter password"
//               onKeyDown={(e) => e.key === "Enter" && handleLogin()}
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <button
//             onClick={handleLogin}
//             disabled={loading}
//             style={{
//               padding: "12px",
//               borderRadius: 8,
//               border: "none",
//               background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//               color: "#fff",
//               fontWeight: 700,
//               fontSize: 14,
//               cursor: "pointer",
//               opacity: loading ? 0.7 : 1,
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {loading ? "Logging in..." : "Access Super Admin →"}
//           </button>
//           {error && (
//             <div
//               style={{ color: "#dc2626", fontSize: 12, textAlign: "center" }}
//             >
//               {error}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function SuperAdmin() {
//   const navigate = useNavigate();
//   const [loggedIn, setLoggedIn] = useState(!!getToken());
//   const [username, setUsername] = useState("");
//   const [hospitals, setHospitals] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState("");
//   const [search, setSearch] = useState("");
//   const [filterStatus, setFilter] = useState("all");

//   const showToast = (msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(""), 3500);
//   };

//   const load = useCallback(async () => {
//     if (!loggedIn) return;
//     setLoading(true);
//     try {
//       const [h, s] = await Promise.all([
//         saFetch(`/hospitals?_t=${Date.now()}`),
//         saFetch(`/stats?_t=${Date.now()}`),
//       ]);
//       setHospitals(h);
//       setStats(s);
//     } catch (err) {
//       if (err.message === "Invalid token." || err.message === "No token.") {
//         localStorage.removeItem(TK);
//         setLoggedIn(false);
//       }
//       showToast("❌ " + err.message);
//     }
//     setLoading(false);
//   }, [loggedIn]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   // ✅ Auto-refresh every 5 minutes so daysLeft stays accurate
//   useEffect(() => {
//     const t = setInterval(load, 300000);
//     return () => clearInterval(t);
//   }, [load]);

//   const handleAction = async (id, action) => {
//     try {
//       if (action === "extend") {
//         await saFetch(`/hospitals/${id}/extend-trial`, {
//           method: "PATCH",
//           body: JSON.stringify({ days: 14 }),
//         });
//         showToast("✅ Trial extended by 14 days!");
//       } else {
//         await saFetch(`/hospitals/${id}/status`, {
//           method: "PATCH",
//           body: JSON.stringify({ status: action }),
//         });
//         showToast(`✅ Status updated to ${action}!`);
//       }
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//     }
//   };

//   const handleDelete = async (h) => {
//     if (
//       !window.confirm(
//         `DELETE "${h.name}"?\n\nThis will permanently delete:\n• All doctors\n• All patients\n• All appointments\n\nThis CANNOT be undone!`,
//       )
//     )
//       return;
//     try {
//       await saFetch(`/hospitals/${h._id}`, { method: "DELETE" });
//       showToast(`✅ "${h.name}" deleted!`);
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//     }
//   };

//   if (!loggedIn) {
//     return (
//       <LoginScreen
//         onLogin={(u) => {
//           setLoggedIn(true);
//           setUsername(u);
//         }}
//       />
//     );
//   }

//   const filtered = hospitals.filter((h) => {
//     const matchSearch =
//       !search ||
//       h.name.toLowerCase().includes(search.toLowerCase()) ||
//       h.city?.toLowerCase().includes(search.toLowerCase());
//     const matchStatus =
//       filterStatus === "all" || h.subscriptionStatus === filterStatus;
//     return matchSearch && matchStatus;
//   });

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: "'DM Sans',sans-serif",
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           padding: "20px 32px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <span style={{ fontSize: 28 }}>🛡️</span>
//           <div>
//             <div style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>
//               VidyaOne Super Admin
//             </div>
//             <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//               Platform Management
//             </div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.08)",
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             ← VidyaOne
//           </button>
//           <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//             👋 {username}
//           </span>
//           <button
//             onClick={() => {
//               localStorage.removeItem(TK);
//               setLoggedIn(false);
//             }}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.1)",
//               color: "#fff",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             Logout
//           </button>
//         </div>
//       </div>

//       <div style={{ maxWidth: 1000, margin: "0 auto", padding: "28px 24px" }}>
//         {/* Stats */}
//         {stats && (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
//               gap: 12,
//               marginBottom: 24,
//             }}
//           >
//             {[
//               { label: "Total hospitals", value: stats.totalHospitals },
//               { label: "Active", value: stats.activeHospitals },
//               { label: "On trial", value: stats.trialHospitals },
//               { label: "Blocked", value: stats.blockedHospitals },
//               { label: "Total doctors", value: stats.totalDoctors },
//               { label: "Total patients", value: stats.totalPatients },
//               { label: "Appointments", value: stats.totalAppointments },
//             ].map((s) => (
//               <div
//                 key={s.label}
//                 style={{
//                   background: "#fff",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: 12,
//                   padding: "14px 16px",
//                 }}
//               >
//                 <div
//                   style={{ fontSize: 22, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
//                   {s.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Filters */}
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             marginBottom: 18,
//             flexWrap: "wrap",
//             alignItems: "center",
//           }}
//         >
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search hospital or city..."
//             style={{
//               flex: 1,
//               minWidth: 180,
//               padding: "9px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               fontSize: 13,
//               outline: "none",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           />
//           {["all", "trial", "active", "blocked", "expired"].map((s) => (
//             <button
//               key={s}
//               onClick={() => setFilter(s)}
//               style={{
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 border: "1px solid",
//                 cursor: "pointer",
//                 fontFamily: "'DM Sans',sans-serif",
//                 borderColor: filterStatus === s ? "#0d7377" : "#d1d5db",
//                 background: filterStatus === s ? "#0d7377" : "#fff",
//                 color: filterStatus === s ? "#fff" : "#374151",
//               }}
//             >
//               {s.charAt(0).toUpperCase() + s.slice(1)}
//             </button>
//           ))}
//           <button
//             onClick={load}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             🔄 Refresh
//           </button>
//         </div>

//         <div
//           style={{
//             marginBottom: 12,
//             fontSize: 13,
//             fontWeight: 700,
//             color: "#1e293b",
//           }}
//         >
//           {filtered.length} hospital{filtered.length !== 1 ? "s" : ""}
//           {filterStatus !== "all" && ` · ${filterStatus}`}
//         </div>

//         {loading ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             Loading hospitals...
//           </div>
//         ) : filtered.length === 0 ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             No hospitals found.
//           </div>
//         ) : (
//           filtered.map((h) => (
//             <HospitalRow
//               key={h._id}
//               h={h}
//               onAction={handleAction}
//               onDelete={handleDelete}
//             />
//           ))
//         )}
//       </div>

//       {/* Toast */}
//       {toast && (
//         <div
//           style={{
//             position: "fixed",
//             bottom: 24,
//             right: 24,
//             background: "#0a1628",
//             color: "#fff",
//             padding: "12px 20px",
//             borderRadius: 10,
//             fontSize: 13,
//             fontWeight: 600,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
//             zIndex: 9999,
//           }}
//         >
//           {toast}
//         </div>
//       )}
//     </div>
//   );
// }

///////////////// 3days added
// // ============================================================
// // src/pages/SuperAdmin.js
// // ✅ Fixed token reading on every request
// // ✅ Fixed daysLeft calculation (floor from start of today)
// // ✅ Auto-refresh every 5 minutes
// // ✅ +3 days grace button added
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
// const TK = "vidyaone_sa_token";
// const getToken = () => localStorage.getItem(TK);

// const saFetch = async (path, options = {}) => {
//   const token = getToken();
//   const res = await fetch(`${BASE}/superadmin${path}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//   });
//   if (!res.ok) {
//     const err = await res.json().catch(() => ({ message: "Request failed" }));
//     throw new Error(err.message || "Request failed");
//   }
//   return res.json();
// };

// function StatusBadge({ status }) {
//   const map = {
//     trial: { bg: "#fff8e1", color: "#b45309", label: "Trial" },
//     active: { bg: "#f0fdf4", color: "#166534", label: "Active" },
//     blocked: { bg: "#fef2f2", color: "#991b1b", label: "Blocked" },
//     expired: { bg: "#f8fafc", color: "#64748b", label: "Expired" },
//   };
//   const s = map[status] || map.expired;
//   return (
//     <span
//       style={{
//         padding: "3px 10px",
//         borderRadius: 20,
//         fontSize: 11,
//         fontWeight: 700,
//         background: s.bg,
//         color: s.color,
//         border: `1px solid ${s.color}40`,
//       }}
//     >
//       {s.label}
//     </span>
//   );
// }

// function HospitalRow({ h, onAction, onDelete }) {
//   const expiry = h.subscriptionExpiry ? new Date(h.subscriptionExpiry) : null;
//   const now = new Date();
//   now.setHours(0, 0, 0, 0);
//   const daysLeft = expiry ? Math.floor((expiry - now) / 86400000) : null;

//   // ✅ If daysLeft <= 0 treat as expired visually regardless of DB status
//   const displayStatus =
//     daysLeft !== null && daysLeft <= 0 && h.subscriptionStatus !== "active"
//       ? "expired"
//       : h.subscriptionStatus;

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 14,
//         padding: "16px 20px",
//         marginBottom: 12,
//         boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ flex: 1, minWidth: 200 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 8,
//               marginBottom: 4,
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//               {h.name}
//             </div>
//             <StatusBadge status={displayStatus} />
//             {h.slug === "pearlsmile" && (
//               <span
//                 style={{
//                   padding: "2px 8px",
//                   borderRadius: 20,
//                   fontSize: 10,
//                   fontWeight: 700,
//                   background: "#e0f2fe",
//                   color: "#0369a1",
//                 }}
//               >
//                 Original
//               </span>
//             )}
//           </div>
//           <div style={{ fontSize: 12, color: "#64748b" }}>
//             {h.city} · {h.type || "Dental"} · /{h.slug}
//           </div>
//           <div
//             style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}
//           >
//             {[
//               { label: "Doctors", value: h.doctorCount || 0 },
//               { label: "Patients", value: h.patientCount || 0 },
//               { label: "Appointments", value: h.appointmentCount || 0 },
//             ].map((s) => (
//               <div key={s.label} style={{ textAlign: "center" }}>
//                 <div
//                   style={{ fontSize: 16, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>{s.label}</div>
//               </div>
//             ))}
//             {expiry && (
//               <div style={{ textAlign: "center" }}>
//                 <div
//                   style={{
//                     fontSize: 16,
//                     fontWeight: 700,
//                     color:
//                       daysLeft < 3
//                         ? "#dc2626"
//                         : daysLeft < 7
//                           ? "#d97706"
//                           : "#0a1628",
//                   }}
//                 >
//                   {daysLeft <= 0 ? "Exp" : `${daysLeft}d`}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#94a3b8" }}>Days left</div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action buttons */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: 6,
//             flexShrink: 0,
//           }}
//         >
//           {h.subscriptionStatus !== "active" && (
//             <button onClick={() => onAction(h._id, "active")} style={BTN_GREEN}>
//               ✅ Activate
//             </button>
//           )}
//           {h.subscriptionStatus !== "blocked" && h.slug !== "pearlsmile" && (
//             <button onClick={() => onAction(h._id, "blocked")} style={BTN_RED}>
//               🚫 Block
//             </button>
//           )}
//           {/* ✅ +3 days grace button */}
//           <button onClick={() => onAction(h._id, "extend3")} style={BTN_ORANGE}>
//             ⏳ +3 days
//           </button>
//           <button onClick={() => onAction(h._id, "extend")} style={BTN_BLUE}>
//             📅 +14 days
//           </button>
//           {h.slug !== "pearlsmile" && (
//             <button
//               onClick={() => onDelete(h)}
//               style={{ ...BTN_RED, background: "#fef2f2" }}
//             >
//               🗑️ Delete
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         style={{
//           marginTop: 10,
//           paddingTop: 10,
//           borderTop: "1px solid #f1f5f9",
//           display: "flex",
//           gap: 16,
//           fontSize: 12,
//           color: "#64748b",
//           flexWrap: "wrap",
//         }}
//       >
//         <span>📞 {h.phone || "—"}</span>
//         <span>✉️ {h.email || "—"}</span>
//         <span>🗓️ Est. {h.established || "—"}</span>
//         <span
//           style={{ marginLeft: "auto", fontFamily: "monospace", fontSize: 11 }}
//         >
//           {new Date(h.createdAt).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           })}
//         </span>
//       </div>
//     </div>
//   );
// }

// const BTN = {
//   padding: "6px 12px",
//   borderRadius: 7,
//   border: "1px solid",
//   fontSize: 11,
//   fontWeight: 700,
//   cursor: "pointer",
//   fontFamily: "'DM Sans',sans-serif",
//   whiteSpace: "nowrap",
// };
// const BTN_GREEN = {
//   ...BTN,
//   borderColor: "#16a34a",
//   color: "#166534",
//   background: "#f0fdf4",
// };
// const BTN_RED = {
//   ...BTN,
//   borderColor: "#dc2626",
//   color: "#991b1b",
//   background: "#fff",
// };
// const BTN_BLUE = {
//   ...BTN,
//   borderColor: "#2563eb",
//   color: "#1d4ed8",
//   background: "#eff6ff",
// };
// const BTN_ORANGE = {
//   ...BTN,
//   borderColor: "#d97706",
//   color: "#92400e",
//   background: "#fffbeb",
// };

// function LoginScreen({ onLogin }) {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleLogin = async () => {
//     if (!username || !password) {
//       setError("Enter username and password.");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     try {
//       const res = await fetch(`${BASE}/superadmin/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);
//       localStorage.setItem(TK, data.token);
//       onLogin(data.username);
//     } catch (err) {
//       setError(err.message || "Login failed.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg,#0a1628,#0d2444)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 24,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           padding: "40px 36px",
//           width: "100%",
//           maxWidth: 400,
//           boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//         }}
//       >
//         <div style={{ textAlign: "center", marginBottom: 28 }}>
//           <div style={{ fontSize: 48, marginBottom: 8 }}>🛡️</div>
//           <h1
//             style={{
//               fontSize: 22,
//               fontWeight: 800,
//               color: "#0a1628",
//               margin: 0,
//             }}
//           >
//             VidyaOne
//           </h1>
//           <p style={{ color: "#64748b", fontSize: 13, marginTop: 4 }}>
//             Super Admin Panel
//           </p>
//         </div>
//         <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//           <div>
//             <div
//               style={{
//                 background: "rgba(220,38,38,0.08)",
//                 border: "1px solid rgba(220,38,38,0.25)",
//                 borderRadius: 10,
//                 padding: "12px 16px",
//                 marginBottom: 20,
//                 textAlign: "center",
//               }}
//             >
//               <div style={{ fontSize: 18, marginBottom: 6 }}>🔒</div>
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 700,
//                   color: "#dc2626",
//                   marginBottom: 4,
//                 }}
//               >
//                 Restricted Access
//               </div>
//               <div style={{ fontSize: 12, color: "#7f1d1d", lineHeight: 1.6 }}>
//                 This area is exclusively reserved for{" "}
//                 <strong>VidyaOne Platform Administrators</strong>. Unauthorized
//                 access attempts are monitored and logged. If you are not a
//                 VidyaOne admin, please leave immediately.
//               </div>
//             </div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Username
//             </label>
//             <input
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               placeholder="vidyaone_admin"
//               autoComplete="off"
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <div>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#64748b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 display: "block",
//                 marginBottom: 5,
//               }}
//             >
//               Password
//             </label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter password"
//               onKeyDown={(e) => e.key === "Enter" && handleLogin()}
//               style={{
//                 width: "100%",
//                 padding: "10px 12px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 fontSize: 13,
//                 outline: "none",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>
//           <button
//             onClick={handleLogin}
//             disabled={loading}
//             style={{
//               padding: "12px",
//               borderRadius: 8,
//               border: "none",
//               background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//               color: "#fff",
//               fontWeight: 700,
//               fontSize: 14,
//               cursor: "pointer",
//               opacity: loading ? 0.7 : 1,
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {loading ? "Logging in..." : "Access Super Admin →"}
//           </button>
//           {error && (
//             <div
//               style={{ color: "#dc2626", fontSize: 12, textAlign: "center" }}
//             >
//               {error}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function SuperAdmin() {
//   const navigate = useNavigate();
//   const [loggedIn, setLoggedIn] = useState(!!getToken());
//   const [username, setUsername] = useState("");
//   const [hospitals, setHospitals] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState("");
//   const [search, setSearch] = useState("");
//   const [filterStatus, setFilter] = useState("all");
//   const [deleteTarget, setDeleteTarget] = useState(null);

//   const showToast = (msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(""), 3500);
//   };

//   const load = useCallback(async () => {
//     if (!loggedIn) return;
//     setLoading(true);
//     try {
//       const [h, s] = await Promise.all([
//         saFetch(`/hospitals?_t=${Date.now()}`),
//         saFetch(`/stats?_t=${Date.now()}`),
//       ]);
//       setHospitals(h);
//       setStats(s);
//     } catch (err) {
//       if (err.message === "Invalid token." || err.message === "No token.") {
//         localStorage.removeItem(TK);
//         setLoggedIn(false);
//       }
//       showToast("❌ " + err.message);
//     }
//     setLoading(false);
//   }, [loggedIn]);

//   useEffect(() => {
//     load();
//   }, [load]);
//   useEffect(() => {
//     const t = setInterval(load, 300000);
//     return () => clearInterval(t);
//   }, [load]);

//   const handleAction = async (id, action) => {
//     try {
//       if (action === "extend") {
//         // +14 days
//         await saFetch(`/hospitals/${id}/extend-trial`, {
//           method: "PATCH",
//           body: JSON.stringify({ days: 14 }),
//         });
//         showToast("✅ Trial extended by 14 days!");
//       } else if (action === "extend3") {
//         // ✅ +3 days grace period
//         await saFetch(`/hospitals/${id}/extend-trial`, {
//           method: "PATCH",
//           body: JSON.stringify({ days: 3 }),
//         });
//         showToast("✅ Grace period extended by 3 days!");
//       } else {
//         await saFetch(`/hospitals/${id}/status`, {
//           method: "PATCH",
//           body: JSON.stringify({ status: action }),
//         });
//         showToast(`✅ Status updated to ${action}!`);
//       }
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//     }
//   };

//   const handleDelete = (h) => setDeleteTarget(h);

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await saFetch(`/hospitals/${deleteTarget._id}`, { method: "DELETE" });
//       showToast(`✅ "${deleteTarget.name}" deleted permanently!`);
//       setDeleteTarget(null);
//       load();
//     } catch (err) {
//       showToast("❌ " + err.message);
//       setDeleteTarget(null);
//     }
//   };

//   if (!loggedIn) {
//     return (
//       <LoginScreen
//         onLogin={(u) => {
//           setLoggedIn(true);
//           setUsername(u);
//         }}
//       />
//     );
//   }

//   const filtered = hospitals.filter((h) => {
//     const matchSearch =
//       !search ||
//       h.name.toLowerCase().includes(search.toLowerCase()) ||
//       h.city?.toLowerCase().includes(search.toLowerCase());
//     const matchStatus =
//       filterStatus === "all" || h.subscriptionStatus === filterStatus;
//     return matchSearch && matchStatus;
//   });

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: "'DM Sans',sans-serif",
//       }}
//     >
//       {/* Delete Confirm Modal */}
//       {deleteTarget && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.65)",
//             backdropFilter: "blur(4px)",
//             zIndex: 9999,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: 20,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: 20,
//               width: "100%",
//               maxWidth: 460,
//               boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 background: "linear-gradient(135deg,#7f1d1d,#dc2626)",
//                 padding: "20px 24px",
//               }}
//             >
//               <div style={{ fontSize: 32, marginBottom: 6 }}>🗑️</div>
//               <div style={{ fontSize: 17, fontWeight: 800, color: "#fff" }}>
//                 Delete Hospital
//               </div>
//               <div
//                 style={{
//                   fontSize: 12,
//                   color: "rgba(255,255,255,0.7)",
//                   marginTop: 3,
//                 }}
//               >
//                 This action is permanent and cannot be undone
//               </div>
//             </div>
//             <div style={{ padding: 24 }}>
//               <div
//                 style={{
//                   background: "#fef2f2",
//                   border: "1px solid #fecaca",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 14,
//                     fontWeight: 700,
//                     color: "#991b1b",
//                     marginBottom: 4,
//                   }}
//                 >
//                   {deleteTarget.name}
//                 </div>
//                 <div style={{ fontSize: 12, color: "#dc2626" }}>
//                   📍 {deleteTarget.city} · {deleteTarget.type}
//                 </div>
//               </div>
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#374151",
//                   marginBottom: 20,
//                   lineHeight: 1.8,
//                 }}
//               >
//                 <div
//                   style={{ fontWeight: 700, color: "#dc2626", marginBottom: 8 }}
//                 >
//                   ⚠️ This will permanently delete:
//                 </div>
//                 <div>• All hospital settings & data</div>
//                 <div>• All doctor accounts</div>
//                 <div>• All patient profiles</div>
//                 <div>• All appointments & billing</div>
//               </div>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setDeleteTarget(null)}
//                   style={{
//                     flex: 1,
//                     padding: 11,
//                     borderRadius: 9,
//                     border: "1px solid #e5e7eb",
//                     background: "#f8fafc",
//                     color: "#374151",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                   }}
//                 >
//                   Cancel — Keep Hospital
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   style={{
//                     flex: 1,
//                     padding: 11,
//                     borderRadius: 9,
//                     border: "none",
//                     background: "linear-gradient(135deg,#7f1d1d,#dc2626)",
//                     color: "#fff",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                   }}
//                 >
//                   🗑️ Yes, Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <div
//         style={{
//           background: "linear-gradient(135deg,#0a1628,#0d2444)",
//           padding: "20px 32px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//           <span style={{ fontSize: 28 }}>🛡️</span>
//           <div>
//             <div style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>
//               VidyaOne Super Admin
//             </div>
//             <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//               Platform Management
//             </div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.08)",
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             ← VidyaOne
//           </button>
//           <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
//             👋 {username}
//           </span>
//           <button
//             onClick={() => {
//               localStorage.removeItem(TK);
//               setLoggedIn(false);
//             }}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid rgba(255,255,255,0.2)",
//               background: "rgba(255,255,255,0.1)",
//               color: "#fff",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             Logout
//           </button>
//         </div>
//       </div>

//       <div style={{ maxWidth: 1000, margin: "0 auto", padding: "28px 24px" }}>
//         {/* Stats */}
//         {stats && (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
//               gap: 12,
//               marginBottom: 24,
//             }}
//           >
//             {[
//               { label: "Total hospitals", value: stats.totalHospitals },
//               { label: "Active", value: stats.activeHospitals },
//               { label: "On trial", value: stats.trialHospitals },
//               { label: "Blocked", value: stats.blockedHospitals },
//               { label: "Total doctors", value: stats.totalDoctors },
//               { label: "Total patients", value: stats.totalPatients },
//               { label: "Appointments", value: stats.totalAppointments },
//             ].map((s) => (
//               <div
//                 key={s.label}
//                 style={{
//                   background: "#fff",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: 12,
//                   padding: "14px 16px",
//                 }}
//               >
//                 <div
//                   style={{ fontSize: 22, fontWeight: 700, color: "#0a1628" }}
//                 >
//                   {s.value}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
//                   {s.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Filters */}
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             marginBottom: 18,
//             flexWrap: "wrap",
//             alignItems: "center",
//           }}
//         >
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search hospital or city..."
//             style={{
//               flex: 1,
//               minWidth: 180,
//               padding: "9px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               fontSize: 13,
//               outline: "none",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           />
//           {["all", "trial", "active", "blocked", "expired"].map((s) => (
//             <button
//               key={s}
//               onClick={() => setFilter(s)}
//               style={{
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 fontSize: 12,
//                 fontWeight: 600,
//                 border: "1px solid",
//                 cursor: "pointer",
//                 fontFamily: "'DM Sans',sans-serif",
//                 borderColor: filterStatus === s ? "#0d7377" : "#d1d5db",
//                 background: filterStatus === s ? "#0d7377" : "#fff",
//                 color: filterStatus === s ? "#fff" : "#374151",
//               }}
//             >
//               {s.charAt(0).toUpperCase() + s.slice(1)}
//             </button>
//           ))}
//           <button
//             onClick={load}
//             style={{
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             🔄 Refresh
//           </button>
//         </div>

//         <div
//           style={{
//             marginBottom: 12,
//             fontSize: 13,
//             fontWeight: 700,
//             color: "#1e293b",
//           }}
//         >
//           {filtered.length} hospital{filtered.length !== 1 ? "s" : ""}
//           {filterStatus !== "all" && ` · ${filterStatus}`}
//         </div>

//         {loading ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             Loading hospitals...
//           </div>
//         ) : filtered.length === 0 ? (
//           <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
//             No hospitals found.
//           </div>
//         ) : (
//           filtered.map((h) => (
//             <HospitalRow
//               key={h._id}
//               h={h}
//               onAction={handleAction}
//               onDelete={handleDelete}
//             />
//           ))
//         )}
//       </div>

//       {/* Toast */}
//       {toast && (
//         <div
//           style={{
//             position: "fixed",
//             bottom: 24,
//             right: 24,
//             background: "#0a1628",
//             color: "#fff",
//             padding: "12px 20px",
//             borderRadius: 10,
//             fontSize: 13,
//             fontWeight: 600,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
//             zIndex: 9999,
//           }}
//         >
//           {toast}
//         </div>
//       )}
//     </div>
//   );
// }

// pranjeev
// ============================================================
// src/pages/SuperAdmin.js
// ✅ Fixed token reading on every request
// ✅ Fixed daysLeft calculation (floor from start of today)
// ✅ Auto-refresh every 5 minutes
// ✅ +3 days grace button added
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const TK = "pranjeev_sa_token";
const getToken = () => localStorage.getItem(TK);

const saFetch = async (path, options = {}) => {
  const token = getToken();
  const res = await fetch(`${BASE}/superadmin${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: "Request failed" }));
    throw new Error(err.message || "Request failed");
  }
  return res.json();
};

function StatusBadge({ status }) {
  const map = {
    trial: { bg: "#fff8e1", color: "#b45309", label: "Trial" },
    active: { bg: "#f0fdf4", color: "#166534", label: "Active" },
    blocked: { bg: "#fef2f2", color: "#991b1b", label: "Blocked" },
    expired: { bg: "#f8fafc", color: "#64748b", label: "Expired" },
  };
  const s = map[status] || map.expired;
  return (
    <span
      style={{
        padding: "3px 10px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
        background: s.bg,
        color: s.color,
        border: `1px solid ${s.color}40`,
      }}
    >
      {s.label}
    </span>
  );
}

function HospitalRow({ h, onAction, onDelete }) {
  const expiry = h.subscriptionExpiry ? new Date(h.subscriptionExpiry) : null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const daysLeft = expiry ? Math.floor((expiry - now) / 86400000) : null;

  // ✅ If daysLeft <= 0 treat as expired visually regardless of DB status
  const displayStatus =
    daysLeft !== null && daysLeft <= 0 && h.subscriptionStatus !== "active"
      ? "expired"
      : h.subscriptionStatus;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 14,
        padding: "16px 20px",
        marginBottom: 12,
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ flex: 1, minWidth: 200 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 4,
              flexWrap: "wrap",
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
              {h.name}
            </div>
            <StatusBadge status={displayStatus} />
            {h.slug === "pearlsmile" && (
              <span
                style={{
                  padding: "2px 8px",
                  borderRadius: 20,
                  fontSize: 10,
                  fontWeight: 700,
                  background: "#e0f2fe",
                  color: "#0369a1",
                }}
              >
                Original
              </span>
            )}
          </div>
          <div style={{ fontSize: 12, color: "#64748b" }}>
            {h.city} · {h.type || "Dental"} · /{h.slug}
          </div>
          <div
            style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}
          >
            {[
              { label: "Doctors", value: h.doctorCount || 0 },
              { label: "Patients", value: h.patientCount || 0 },
              { label: "Appointments", value: h.appointmentCount || 0 },
            ].map((s) => (
              <div key={s.label} style={{ textAlign: "center" }}>
                <div
                  style={{ fontSize: 16, fontWeight: 700, color: "#0a1628" }}
                >
                  {s.value}
                </div>
                <div style={{ fontSize: 10, color: "#94a3b8" }}>{s.label}</div>
              </div>
            ))}
            {expiry && (
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color:
                      daysLeft < 3
                        ? "#dc2626"
                        : daysLeft < 7
                          ? "#d97706"
                          : "#0a1628",
                  }}
                >
                  {daysLeft <= 0 ? "Exp" : `${daysLeft}d`}
                </div>
                <div style={{ fontSize: 10, color: "#94a3b8" }}>Days left</div>
              </div>
            )}
          </div>
        </div>

        {/* Action buttons */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            flexShrink: 0,
          }}
        >
          {h.subscriptionStatus !== "active" && (
            <button onClick={() => onAction(h._id, "active")} style={BTN_GREEN}>
              ✅ Activate
            </button>
          )}
          {h.subscriptionStatus !== "blocked" && h.slug !== "pearlsmile" && (
            <button onClick={() => onAction(h._id, "blocked")} style={BTN_RED}>
              🚫 Block
            </button>
          )}
          {/* ✅ +3 days grace button */}
          <button onClick={() => onAction(h._id, "extend3")} style={BTN_ORANGE}>
            ⏳ +3 days
          </button>
          <button onClick={() => onAction(h._id, "extend")} style={BTN_BLUE}>
            📅 +14 days
          </button>
          {h.slug !== "pearlsmile" && (
            <button
              onClick={() => onDelete(h)}
              style={{ ...BTN_RED, background: "#fef2f2" }}
            >
              🗑️ Delete
            </button>
          )}
        </div>
      </div>

      <div
        style={{
          marginTop: 10,
          paddingTop: 10,
          borderTop: "1px solid #f1f5f9",
          display: "flex",
          gap: 16,
          fontSize: 12,
          color: "#64748b",
          flexWrap: "wrap",
        }}
      >
        <span>📞 {h.phone || "—"}</span>
        <span>✉️ {h.email || "—"}</span>
        <span>🗓️ Est. {h.established || "—"}</span>
        <span
          style={{ marginLeft: "auto", fontFamily: "monospace", fontSize: 11 }}
        >
          {new Date(h.createdAt).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}
        </span>
      </div>
    </div>
  );
}

const BTN = {
  padding: "6px 12px",
  borderRadius: 7,
  border: "1px solid",
  fontSize: 11,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: "'DM Sans',sans-serif",
  whiteSpace: "nowrap",
};
const BTN_GREEN = {
  ...BTN,
  borderColor: "#16a34a",
  color: "#166534",
  background: "#f0fdf4",
};
const BTN_RED = {
  ...BTN,
  borderColor: "#dc2626",
  color: "#991b1b",
  background: "#fff",
};
const BTN_BLUE = {
  ...BTN,
  borderColor: "#2563eb",
  color: "#1d4ed8",
  background: "#eff6ff",
};
const BTN_ORANGE = {
  ...BTN,
  borderColor: "#d97706",
  color: "#92400e",
  background: "#fffbeb",
};

function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      setError("Enter username and password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BASE}/superadmin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      localStorage.setItem(TK, data.token);
      onLogin(data.username);
    } catch (err) {
      setError(err.message || "Login failed.");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#0a1628,#0d2444)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          padding: "40px 36px",
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🛡️</div>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#0a1628",
              margin: 0,
            }}
          >
            PranJeev
          </h1>
          <p style={{ color: "#64748b", fontSize: 13, marginTop: 4 }}>
            Super Admin Panel
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <div
              style={{
                background: "rgba(220,38,38,0.08)",
                border: "1px solid rgba(220,38,38,0.25)",
                borderRadius: 10,
                padding: "12px 16px",
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 18, marginBottom: 6 }}>🔒</div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#dc2626",
                  marginBottom: 4,
                }}
              >
                Restricted Access
              </div>
              <div style={{ fontSize: 12, color: "#7f1d1d", lineHeight: 1.6 }}>
                This area is exclusively reserved for{" "}
                <strong>PranJeev Platform Administrators</strong>. Unauthorized
                access attempts are monitored and logged. If you are not a
                PranJeev admin, please leave immediately.
              </div>
            </div>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "block",
                marginBottom: 5,
              }}
            >
              Username
            </label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="pranjeev_admin"
              autoComplete="off"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 13,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>
          <div>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "block",
                marginBottom: 5,
              }}
            >
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 13,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              padding: "12px",
              borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              opacity: loading ? 0.7 : 1,
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {loading ? "Logging in..." : "Access Super Admin →"}
          </button>
          {error && (
            <div
              style={{ color: "#dc2626", fontSize: 12, textAlign: "center" }}
            >
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function SuperAdmin() {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(!!getToken());
  const [username, setUsername] = useState("");
  const [hospitals, setHospitals] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [search, setSearch] = useState("");
  const [filterStatus, setFilter] = useState("all");
  const [deleteTarget, setDeleteTarget] = useState(null);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 3500);
  };

  const load = useCallback(async () => {
    if (!loggedIn) return;
    setLoading(true);
    try {
      const [h, s] = await Promise.all([
        saFetch(`/hospitals?_t=${Date.now()}`),
        saFetch(`/stats?_t=${Date.now()}`),
      ]);
      setHospitals(h);
      setStats(s);
    } catch (err) {
      if (err.message === "Invalid token." || err.message === "No token.") {
        localStorage.removeItem(TK);
        setLoggedIn(false);
      }
      showToast("❌ " + err.message);
    }
    setLoading(false);
  }, [loggedIn]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, [load]);

  const handleAction = async (id, action) => {
    try {
      if (action === "extend") {
        // +14 days
        await saFetch(`/hospitals/${id}/extend-trial`, {
          method: "PATCH",
          body: JSON.stringify({ days: 14 }),
        });
        showToast("✅ Trial extended by 14 days!");
      } else if (action === "extend3") {
        // ✅ +3 days grace period
        await saFetch(`/hospitals/${id}/extend-trial`, {
          method: "PATCH",
          body: JSON.stringify({ days: 3 }),
        });
        showToast("✅ Grace period extended by 3 days!");
      } else {
        await saFetch(`/hospitals/${id}/status`, {
          method: "PATCH",
          body: JSON.stringify({ status: action }),
        });
        showToast(`✅ Status updated to ${action}!`);
      }
      load();
    } catch (err) {
      showToast("❌ " + err.message);
    }
  };

  const handleDelete = (h) => setDeleteTarget(h);

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await saFetch(`/hospitals/${deleteTarget._id}`, { method: "DELETE" });
      showToast(`✅ "${deleteTarget.name}" deleted permanently!`);
      setDeleteTarget(null);
      load();
    } catch (err) {
      showToast("❌ " + err.message);
      setDeleteTarget(null);
    }
  };

  if (!loggedIn) {
    return (
      <LoginScreen
        onLogin={(u) => {
          setLoggedIn(true);
          setUsername(u);
        }}
      />
    );
  }

  const filtered = hospitals.filter((h) => {
    const matchSearch =
      !search ||
      h.name.toLowerCase().includes(search.toLowerCase()) ||
      h.city?.toLowerCase().includes(search.toLowerCase());
    const matchStatus =
      filterStatus === "all" || h.subscriptionStatus === filterStatus;
    return matchSearch && matchStatus;
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "'DM Sans',sans-serif",
      }}
    >
      {/* Delete Confirm Modal */}
      {deleteTarget && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.65)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 20,
              width: "100%",
              maxWidth: 460,
              boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg,#7f1d1d,#dc2626)",
                padding: "20px 24px",
              }}
            >
              <div style={{ fontSize: 32, marginBottom: 6 }}>🗑️</div>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#fff" }}>
                Delete Hospital
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.7)",
                  marginTop: 3,
                }}
              >
                This action is permanent and cannot be undone
              </div>
            </div>
            <div style={{ padding: 24 }}>
              <div
                style={{
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 10,
                  padding: "12px 16px",
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#991b1b",
                    marginBottom: 4,
                  }}
                >
                  {deleteTarget.name}
                </div>
                <div style={{ fontSize: 12, color: "#dc2626" }}>
                  📍 {deleteTarget.city} · {deleteTarget.type}
                </div>
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "#374151",
                  marginBottom: 20,
                  lineHeight: 1.8,
                }}
              >
                <div
                  style={{ fontWeight: 700, color: "#dc2626", marginBottom: 8 }}
                >
                  ⚠️ This will permanently delete:
                </div>
                <div>• All hospital settings & data</div>
                <div>• All doctor accounts</div>
                <div>• All patient profiles</div>
                <div>• All appointments & billing</div>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button
                  onClick={() => setDeleteTarget(null)}
                  style={{
                    flex: 1,
                    padding: 11,
                    borderRadius: 9,
                    border: "1px solid #e5e7eb",
                    background: "#f8fafc",
                    color: "#374151",
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: "pointer",
                    fontFamily: "DM Sans,sans-serif",
                  }}
                >
                  Cancel — Keep Hospital
                </button>
                <button
                  onClick={confirmDelete}
                  style={{
                    flex: 1,
                    padding: 11,
                    borderRadius: 9,
                    border: "none",
                    background: "linear-gradient(135deg,#7f1d1d,#dc2626)",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: "pointer",
                    fontFamily: "DM Sans,sans-serif",
                  }}
                >
                  🗑️ Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg,#0a1628,#0d2444)",
          padding: "20px 32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 28 }}>🛡️</span>
          <div>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>
              PranJeev Super Admin
            </div>
            <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
              Platform Management
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.08)",
              color: "rgba(255,255,255,0.7)",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            ← PranJeev
          </button>
          <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
            👋 {username}
          </span>
          <button
            onClick={() => {
              localStorage.removeItem(TK);
              setLoggedIn(false);
            }}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            Logout
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "28px 24px" }}>
        {/* Stats */}
        {stats && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
              gap: 12,
              marginBottom: 24,
            }}
          >
            {[
              { label: "Total hospitals", value: stats.totalHospitals },
              { label: "Active", value: stats.activeHospitals },
              { label: "On trial", value: stats.trialHospitals },
              { label: "Blocked", value: stats.blockedHospitals },
              { label: "Total doctors", value: stats.totalDoctors },
              { label: "Total patients", value: stats.totalPatients },
              { label: "Appointments", value: stats.totalAppointments },
            ].map((s) => (
              <div
                key={s.label}
                style={{
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 12,
                  padding: "14px 16px",
                }}
              >
                <div
                  style={{ fontSize: 22, fontWeight: 700, color: "#0a1628" }}
                >
                  {s.value}
                </div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Filters */}
        <div
          style={{
            display: "flex",
            gap: 10,
            marginBottom: 18,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search hospital or city..."
            style={{
              flex: 1,
              minWidth: 180,
              padding: "9px 14px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              fontSize: 13,
              outline: "none",
              fontFamily: "'DM Sans',sans-serif",
            }}
          />
          {["all", "trial", "active", "blocked", "expired"].map((s) => (
            <button
              key={s}
              onClick={() => setFilter(s)}
              style={{
                padding: "8px 14px",
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 600,
                border: "1px solid",
                cursor: "pointer",
                fontFamily: "'DM Sans',sans-serif",
                borderColor: filterStatus === s ? "#0d7377" : "#d1d5db",
                background: filterStatus === s ? "#0d7377" : "#fff",
                color: filterStatus === s ? "#fff" : "#374151",
              }}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
          <button
            onClick={load}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#f8fafc",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            🔄 Refresh
          </button>
        </div>

        <div
          style={{
            marginBottom: 12,
            fontSize: 13,
            fontWeight: 700,
            color: "#1e293b",
          }}
        >
          {filtered.length} hospital{filtered.length !== 1 ? "s" : ""}
          {filterStatus !== "all" && ` · ${filterStatus}`}
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
            Loading hospitals...
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
            No hospitals found.
          </div>
        ) : (
          filtered.map((h) => (
            <HospitalRow
              key={h._id}
              h={h}
              onAction={handleAction}
              onDelete={handleDelete}
            />
          ))
        )}
      </div>

      {/* Toast */}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            background: "#0a1628",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            zIndex: 9999,
          }}
        >
          {toast}
        </div>
      )}
    </div>
  );
}
